import Swiper from 'swiper';
import { Pagination, Controller, Navigation } from 'swiper/modules';

Alpine.data('similarItemsCarousel', () => ({
	showPagination: null,
	init() {
		this.initialiseCarousels();
	},
	initialiseCarousels() {
		new Swiper(this.$refs.image, {
			modules: [Pagination, Controller, Navigation],
			slidesPerView: 3,
			spaceBetween: 34,
			centeredSlides: false,
			autoHeight: false,
			grabCursor: true,
			initialSlide: 0,
			a11y: {
				enabled: true,
				prevSlideMessage: 'Previous item in the list',
				nextSlideMessage: 'Next item in the list',
			},
			// If we need pagination
			pagination: {
				el: this.$refs.pagination,
				clickable: true,
			},
			navigation: {
				nextEl: this.$refs.next,
				prevEl: this.$refs.prev,
			},
			breakpoints: {
				1: {
					slidesPerView: 1,
					spaceBetween: 24,
				},
				375: {
					slidesPerView: 2,
				},
				768: {
					slidesPerView: 3,
					spaceBetween: 34,
				},
			},
			on: {
				init: () => {
					if (this.$refs.pagination.children.length > 1) {
						this.showPagination = true;
					} else {
						this.showPagination = false;
					}
				},
				resize: () => {
					if (this.$refs.pagination.children.length > 1) {
						this.showPagination = true;
					} else {
						this.showPagination = false;
					}
				},
			},
		});
	},
}));
